import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import logo from '../../assets/imeges/WhatsApp_Image_2024-02-02_at_23.08.53_6f259082-removebg-preview.png'
export default function Navbar() {
  return (
    <>
<nav className="navbar navbar-expand-lg bg-body-tertiary">
  <div className="container-fluid">
    <Link className="navbar-brand w-50" to="/Home"><img src={logo} className='w-25' alt="" /></Link>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon" />
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <NavLink className="nav-link" to="/Home">Home</NavLink>
        </li>
        <li className="nav-item">
          <NavLink className="nav-link" to="/About">About</NavLink>
        </li>
        <li className="nav-item">
          <NavLink className="nav-link" to="/Services">Services</NavLink>
        </li>
        <li className="nav-item">
          <NavLink className="nav-link" to="/Contact">ContactUs</NavLink>
        </li>
      </ul>
    </div>
  </div>
</nav>

    </>
  )
}
